import DataTable from "@/components/DataTable/DataTable";
import PropTypes from "prop-types";
import React from "react";
import { FiEdit, FiTrash } from "react-icons/fi";

const FormulasTable = ({
  formulas,
  onDeleteRow,
  onEditRow,
  showPeriodAndFallback,
  page,
  setPage,
  limit,
  setLimit,
  total,
}) => {
  const columns = [
    {
      title: "No",
      render: (_, row) => row.idx,
      width: "60px",
      align: "center",
      show: true,
    },
    {
      title: "Formula Name",
      render: (_, row) => row?.name,
      show: true,
      // align: "center",
    },
    {
      title: "Interval Period (Min)",
      render: (_, row) => row?.intervalPeriod || "--",
      // align: "center",
      show: showPeriodAndFallback,
    },
    {
      title: "Action On Data Not Found",
      render: (_, row) => row?.fallbackBehavior || "--",
      // align: "center",
      show: showPeriodAndFallback,
    },
    {
      title: "Unit / Value",
      render: (_, row) => row?.unit,
      show: true,
      align: "center",
    },
    {
      title: "Formula",
      render: (_, row) => row?.formula,
      show: true,
      // align: "center",
    },
    {
      title: "Description",
      render: (_, row) => row?.description,
      show: true,
    },
    {
      title: "Action",
      show: true,
      render: (_, row) => (
        <div className="actions">
          <button className="btn btn-edit me-2" onClick={() => onEditRow(row)}>
            <FiEdit />
          </button>
          <button className="btn btn-danger" onClick={() => onDeleteRow(row)}>
            <FiTrash />
          </button>
        </div>
      ),
      align: "center",
      width: 100,
    },
  ].filter((item) => item.show);

  return (
    <div>
      <DataTable
        columns={columns}
        dataSource={formulas}
        pagination={{
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          pageSizeOptions: [10, 20, 50],
          responsive: true,
          pageSize: limit,
          current: page,
          total,
        }}
        onChange={(pagination) => {
          setPage(pagination.current);
          setLimit(pagination.pageSize);
        }}
      />
    </div>
  );
};

export default FormulasTable;

FormulasTable.propTypes = {
  formulas: PropTypes.array.isRequired,
  onDeleteRow: PropTypes.func.isRequired,
  onEditRow: PropTypes.func.isRequired,
  showPeriodAndFallback: PropTypes.bool,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  setLimit: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
};
